import { createContext, useContext } from "react";
import { fetchData } from "../../lib/dashboard/data";
import useSWR from "swr";

const DashboardContext = createContext();

const DashboardProvider = ({ children }) => {
  const industriesList = useSWR("/dashboard/industrial-groups", fetchData, {
    revalidateOnFocus: false,
    dedupingInterval: 60 * 1000,
  });

  return (
    <DashboardContext.Provider value={{ industriesList }}>
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardProvider;

export const useDashboardContext = () => {
  return useContext(DashboardContext);
};
